const DA_REVEAL_SELECTORS = [
  '.da-collection-header > *',
  '.product-grid__item',
  '.da-authority3__item',
  '.da-journey__step',
  '.da-comp__card',
  '.box-cta-card',
  '.da-about__content > *',
  '.da-included__box',
  '.da-transf__step',
];

const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const observedElements = new WeakSet();
let revealObserver;

function prepareRevealElements(root = document) {
  const selector = DA_REVEAL_SELECTORS.join(',');
  const elements = [
    ...(root instanceof Element && root.matches(selector) ? [root] : []),
    ...root.querySelectorAll(selector),
  ];

  elements.forEach((element, index) => {
    if (observedElements.has(element)) return;

    observedElements.add(element);
    element.dataset.daReveal = '';
    element.style.setProperty('--da-motion-delay', `${Math.min(index % 4, 3) * 70}ms`);

    if (reducedMotion.matches || !('IntersectionObserver' in window)) {
      element.classList.add('is-da-visible');
      return;
    }

    revealObserver?.observe(element);
  });
}

if (!reducedMotion.matches && 'IntersectionObserver' in window) {
  revealObserver = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        entry.target.classList.add('is-da-visible');
        observer.unobserve(entry.target);
      });
    },
    {
      threshold: 0.08,
      rootMargin: '0px 0px -8% 0px',
    }
  );
}

document.documentElement.classList.add('da-motion-ready');
prepareRevealElements();

document.addEventListener('shopify:section:load', (event) => {
  prepareRevealElements(event.target);
});

const contentObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node instanceof Element) prepareRevealElements(node);
    });
  });
});

contentObserver.observe(document.body, { childList: true, subtree: true });
